import React, { useEffect } from 'react'
import { observer } from 'mobx-react'
import { permissions } from 'settings/permissions'
import { checkPermList } from 'helpers'
import Loader from 'components/UI/Loader/Loader'
import './Reports.module.scss'
import StudentsProgressReports from 'components/Modules/Groups/components/StudentsProgressReports/StudentsProgressReports'
import groupStore from 'Stores/groupStore'
import { useHistory } from 'react-router-dom'

const Reports = (props) => {
  const gid = +props.match.params.id
  const { group } = groupStore
  const history = useHistory()

  useEffect(() => {
    groupStore.fetchGroup(gid)

    return () => {
      groupStore.deleteGroupData()
      history.replace({ state: null })
    }
  }, [gid, history])

  if (!group || !group.group) {
    return <Loader />
  }

  return (
    <div>
      {checkPermList(permissions.view_progress_report) && (
        <StudentsProgressReports
          initialOpen={true}
          id={group.group.id}
          tabLink={false}
        />
      )}
    </div>
  )
}

export default observer(Reports)
